// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul[data-v-ae0bca6e]{width:100%;max-width:600px;margin:0 auto}", ""]);
// Exports
module.exports = exports;
